import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { GroupEntity } from './group.entity';
import { UserEntity } from './user.entity';

@Index('fk_user__id', ['fkUserId'], {})
@Index('group_user_uindex', ['fkUserId', 'fkGroupId'], { unique: true })
@Entity('user_group')
export class UserGroupEntity extends BaseEntity {
	@Column('varchar', { name: 'externalId', nullable: true, length: 64 })
	public externalId!: string | null;

	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	@Column('int', { name: 'fk_group__id', unsigned: true })
	public fkGroupId!: number;

	@ManyToOne(() => UserEntity, (user) => user.userGroups, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_user__id', referencedColumnName: 'id' }])
	public fkUser!: UserEntity;

	@ManyToOne(() => GroupEntity, (group) => group.userGroups, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_group__id', referencedColumnName: 'id' }])
	public fkGroup!: GroupEntity;
}
